<template>
    <div class="dropdown multi-select" ref="dropDownElement">
        <button
            :class="`btn btn-light bg-white dropdown-toggle ${disabled ? 'disabled' : ''} min-w-100`"
            type="button"
            data-bs-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            :disabled="disabled"
        >
            <span>{{ getButtonText }}</span>
        </button>
        <div class="dropdown-menu" ref="dropDownMenu">
            <div class="input-group p-1">
                <input
                    type="text"
                    class="form-control"
                    :placeholder="getSearchPlaceholder"
                    ref="searchInput"
                    v-model="search"
                    :disabled="disabled"
                />
                <div class="input-group-append">
                    <div class="input-group-text">
                        <i class="fas fa-search"></i>
                    </div>
                </div>
            </div>
            <div class="dropdown-divider" v-if="!search"></div>
            <div class="content">
                <div class="dropdown-item p-0 my-1">
                    <div class="form-check ms-0 ps-0">
                        <label class="form-check-label checkbox-hide text-center">
                            <input
                                class="form-check-input"
                                type="checkbox"
                                :value="null"
                                :disabled="disabled"
                                @change.prevent="closeDropDown()"
                            />
                            -- Select {{ labelText }} --
                        </label>
                    </div>
                </div>
                <div v-if="hasGroupLabel && !isList" v-for="groupName of Object.keys(filteredOptions)">
                    <p class="fw-bold text-center mb-0" v-if="groupName && filteredOptions[groupName].length > 0">
                        {{ groupName }}
                    </p>
                    <div
                        v-for="option of filteredOptions[groupName]"
                        :class="`dropdown-item p-0 ps-1 my-1 ${option.value == selectedValue ? 'bg-primary' : ''}`"
                    >
                        <div class="form-check">
                            <label
                                :class="`form-check-label checkbox-hide w-100 d-flex align-items-center white-space-nowrap ${option.relationship === EmployeePreferenceEnum.DoNotSend ? 'disabled' : ''}`"
                            >
                                <input
                                    class="form-check-input"
                                    type="checkbox"
                                    :value="option.value"
                                    :checked="selectedOption.includes(option.value)"
                                    @change.prevent="closeDropDown(option)"
                                    :disabled="option.relationship === EmployeePreferenceEnum.DoNotSend || disabled"
                                />
                                <span class="show-icons" v-html="option.relationshipIcons"></span>
                                <template v-if="showIcons">
                                    <span class="show-icons" v-html="option.icons"> </span>
                                </template>
                                <span class="name-text"> {{ option.displayText }}</span>
                            </label>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <div
                        v-for="option of filteredList"
                        :class="`dropdown-item p-0 ps-1 my-1 ${option.value == selectedValue ? 'bg-primary' : ''}`"
                    >
                        <div class="form-check">
                            <label
                                :class="`form-check-label checkbox-hide w-100 d-flex align-items-center white-space-nowrap ${option.relationship === EmployeePreferenceEnum.DoNotSend ? 'disabled' : ''}`"
                            >
                                <input
                                    class="form-check-input"
                                    type="checkbox"
                                    :value="option.value"
                                    :checked="selectedOption.includes(option.value)"
                                    @change.prevent="closeDropDown(option)"
                                    :disabled="option.relationship === EmployeePreferenceEnum.DoNotSend || disabled"
                                />
                                <span class="show-icons" v-html="option.relationshipIcons"></span>
                                <span class="name-text">{{ option.displayText }}</span>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
            <div class="dropdown-divider"></div>
            <div class="px-1">
                <button type="button" class="btn btn-xs btn-outline-dark w-100" @click="closeDropDown()">Close</button>
            </div>
        </div>
    </div>
</template>

<style lang="scss" src="./GroupDropdownSelect.scss"></style>
<script lang="ts" src="./GroupDropdownSelect"></script>
